import type { ButtonHTMLAttributes } from 'react';

export type SocialProvider = 'facebook' | 'google';

interface SocialAuthButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
    provider: SocialProvider;
}

const labels: Record<SocialProvider, string> = {
    facebook: 'Continuar con Facebook',
    google: 'Continuar con Google',
};

function GoogleMark() {
    return (
        <svg viewBox="0 0 48 48" className="size-6 shrink-0" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 3l5.7-5.7C33.9 6 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-4z" />
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3 0 5.7 1.1 7.8 3l5.7-5.7C33.9 6 29.2 4 24 4c-7.7 0-14.3 4.4-17.7 10.7z" />
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.3 0-9.7-3.3-11.4-7.9L6.1 33C9.5 39.5 16.2 44 24 44z" />
            <path fill="#1976D2" d="M43.6 20H42V20H24v8h11.3c-1 2.7-2.9 4.7-5.1 5.9l6.2 5.2C40.8 35.1 44 30 44 24c0-1.3-.1-2.7-.4-4z" />
        </svg>
    );
}

function FacebookMark() {
    return (
        <svg viewBox="0 0 24 24" className="size-6 shrink-0" aria-hidden="true">
            <circle cx="12" cy="12" r="10" fill="#1877F2" />
            <path fill="#fff" d="M13.4 19v-6h2l.3-2.3h-2.3V9.2c0-.7.2-1.2 1.2-1.2h1.3V6c-.2 0-.9-.1-1.8-.1-1.8 0-3 1.1-3 3.1v1.7H9v2.3h2.1v6h2.3z" />
        </svg>
    );
}

export function SocialAuthButton({ provider, className = '', ...props }: SocialAuthButtonProps) {
    const Icon = provider === 'google' ? GoogleMark : FacebookMark;

    return (
        <button
            type="button"
            className={`inline-flex min-h-14 w-full items-center justify-center gap-3 rounded-xl border border-border bg-surface px-5 text-base font-semibold text-text transition hover:bg-hover active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35 ${className}`}
            {...props}
        >
            <Icon />
            {labels[provider]}
        </button>
    );
}
